import * as React from "react";

import { connect } from "react-redux";

import {
  InputType2,
  SelectType2,
  ButtonType5,
  ButtonType7,
  Tooltip,
} from "@visualizeroi/vroi-custom-components";

import LoadingView from "./LoadingView";

import { UserInfoField } from "./UserInfoField";
import ThankyouView from "./ThankyouView";

import { validateForm, saveVisualizer } from "./../helper/common-methods";

import { Country } from "./Country";
import { State } from "./State";

type Props2 = {
  visualizer_input_output_values: object;
  setUser_modal: Function;
  script_id: string;
  email: string;
  hide_outputs: boolean;
  checkbox: boolean;
  handleCheckBox: Function;
  HANDLE_SHOW_OUTPUTS: Function;
  visualizer_input_output_details: any;
  currency_conversion_rate: any;
  region: any;
};

const UserInfoModal = ({
  visualizer_input_output_values,
  setUser_modal,
  script_id,
  email,
  hide_outputs,
  checkbox,
  handleCheckBox,
  visualizer_input_output_details,
  currency_conversion_rate,
  region,
  HANDLE_SHOW_OUTPUTS,
}: Props2) => {
  const [f_name, setF_name] = React.useState("");
  const [l_name, setL_name] = React.useState("");
  const [local_email, setLocal_email] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [phone, setPhone] = React.useState("");

  // const [state, setState] = React.useState("");
  const [error, setError] = React.useState([""]);
  const [view, setView] = React.useState("user_info");
  const [checked, setChecked] = React.useState(true);

  React.useEffect(() => {
    setLocal_email(email);
  }, [email]);

  const handleSubmit = async () => {
    let errors = await handleValidate("response");
    if (errors.length == 0) {
      console.log("submitted");
      setView("loading");

      let var_values = await handleValuesUpdate();
      HANDLE_SHOW_OUTPUTS();
      saveVisualizer(
        {
          f_name,
          l_name,
          email: local_email,
          company,
          country,
          phone,
        },
        var_values,
        setView,
        script_id,
        region
      );
    }
  };

  const handleValuesUpdate = () => {
    let temp_obj = JSON.parse(JSON.stringify(visualizer_input_output_values));

    Object.keys(visualizer_input_output_details).forEach((e) => {
      if (visualizer_input_output_details[e].representation == "Currency") {
        if (temp_obj.inputs && temp_obj.inputs[e] != undefined) {
          temp_obj.inputs[e] = temp_obj.inputs[e] * currency_conversion_rate;
        }
        if (temp_obj.outputs && temp_obj.outputs[e] != undefined) {
          temp_obj.outputs[e] = temp_obj.outputs[e] * currency_conversion_rate;
        }
      }
    });

    return temp_obj;
  };

  const handleValidate = async (flag = "") => {
    let response = await validateForm({
      f_name,
      l_name,
      email: local_email,
      company,
      checkbox,
      phone,
    });
    setError(response);
    if (flag == "response") {
      return response;
    }
  };

  const handlePrivacyClick = (flag = "") => {
    if (flag == "") {
      window.open("https://diamanti.com/privacy-policy-terms-of-use/");
    } else {
      window.open("https://diamanti.com/privacy-policy-terms-of-use/");
    }
  };

  const onchange = (value) => {
    console.log("Captcha value:", value);
  };

  const handleChange = async (value, name) => {
    switch (name) {
      case "email":
        setLocal_email(value);
        break;
      case "f_name":
        setF_name(value);
        break;
      case "l_name":
        setL_name(value);
        break;
      case "company":
        setCompany(value);
        break;
      case "title":
        setTitle(value);
        break;
      case "phone":
        setPhone(value);
        break;
    }
    if (error.length > 0 && error[0] != "") {
      await handleValidate();
    }
  };

  const handleCountryChange = (e) => {
    setCountry(e.target.value);
    if (error.length > 0 && error[0] != "") {
      handleValidate();
    }
  };

  return (
    <div className="">
      {view == "user_info" ? (
        <>
          <div className="user_info_header_text">Tell us about you</div>
          <div className="user_info_header_desc">
            Fill out the form to download your customized report.
          </div>

          <div className="user_info_div">
            <div className="input_var_label_div">
              <div className="inputs_label">First Name *</div>
              {/* <Tooltip text="we will add later" lines={1} color="black" /> */}
            </div>
            <UserInfoField
              title=""
              name="f_name"
              value={f_name}
              handleChange={handleChange}
              error_msg={""}
              error={error}
              placeholder={""}
            />
          </div>

          <div className="user_info_div">
            <div className="input_var_label_div user_info_label">
              <div className="inputs_label">Last Name *</div>
              {/* <Tooltip text="we will add later" lines={1} color="black" /> */}
            </div>
            <UserInfoField
              title=""
              name="l_name"
              value={l_name}
              handleChange={handleChange}
              error_msg={""}
              error={error}
              placeholder={""}
            />
          </div>

          <div className="user_info_div">
            <div className="input_var_label_div user_info_label">
              <div className="inputs_label">Email *</div>
              {/* <Tooltip text="we will add later" lines={1} color="black" /> */}
            </div>
            <UserInfoField
              title=""
              name="email"
              value={local_email}
              handleChange={handleChange}
              error_msg={""}
              error={error}
              placeholder={""}
            />
          </div>

          <div className="user_info_div">
            <div className="input_var_label_div user_info_label">
              <div className="inputs_label">Company *</div>
              {/* <Tooltip text="we will add later" lines={1} color="black" /> */}
            </div>
            <UserInfoField
              title=""
              name="company"
              value={company}
              handleChange={handleChange}
              error_msg={""}
              error={error}
              placeholder={""}
            />
          </div>

          <div className="user_info_div">
            <div className="input_var_label_div user_info_label">
              <div className="inputs_label">Phone Number *</div>
              {/* <Tooltip text="we will add later" lines={1} color="black" /> */}
            </div>
            <UserInfoField
              title=""
              name="phone"
              value={phone}
              handleChange={handleChange}
              error_msg={""}
              error={error}
              placeholder={""}
            />
          </div>

          <div className="form-check mt15">
            <input
              className="form-check-input"
              type="checkbox"
              value="yes"
              id="marketingOptIn"
              checked={checkbox ? true : false}
              onChange={(e) => handleCheckBox(!checkbox)}
            />
            <label className="form-check-label checkbox_text">
              By checking this box, I agree to receive information and updates,
              including marketing communications, by email about Diamanti’s
              products and services. By submitting this form, I am agreeing to
              Diamanti’s{" "}
              <span className="link" onClick={() => handlePrivacyClick()}>
                privacy policy.
              </span>
            </label>
          </div>
          <div
            className={
              error[0] == "checkbox" ? "error_msg left" : "display_none"
            }
          >
            Please check the checkbox.
          </div>

          <div className="modal_cta_div mt24">
            <button className="Cancel_btn" onClick={() => setUser_modal(false)}>
              Cancel
            </button>

            <button className="submit_btn2" onClick={() => handleSubmit()}>
              EMAIL MY REPORT
            </button>

            <button
              className="Cancel_btn"
              id="cancel_376_screen"
              onClick={() => setUser_modal(false)}
            >
              Cancel
            </button>
          </div>
        </>
      ) : view == "loading" ? (
        <LoadingView />
      ) : (
        <ThankyouView setUser_modal={setUser_modal} setEmail={setLocal_email} />
      )}
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  const { widget_reducer } = state;
  return {
    ...ownProps,
    visualizer_input_output_values:
      widget_reducer.visualizer_input_output_values,
    decorate: widget_reducer.decorate,
    script_id: widget_reducer.script_id,
    email: widget_reducer.email,
    hide_outputs: widget_reducer.hide_outputs,
    checkbox: widget_reducer.checkbox,
    visualizer_input_output_details:
      widget_reducer.visualizer_input_output_details,
    currency_conversion_rate: widget_reducer.currency_conversion_rate,
    region: widget_reducer.region,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleCheckBox: (checkbox) =>
      dispatch({
        type: "HANDLE_CHECKBOX",
        payload: { checkbox },
      }),
    HANDLE_SHOW_OUTPUTS: () => dispatch({ type: "HANDLE_SHOW_OUTPUTS" }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserInfoModal);
